export function flyEmoji() {
  const flyEmoji = document.querySelectorAll('.flyemoji');
  const defaultEmojiList = ["😀", "😂", "😍", "😎", "😜", "🤩", "👍", "🚀", "🌟", "🔥", "🌞", "🌛", "🍑", "🍋"];
  const defaultDuration = 1000;
  const defaultIntervalTime = 50;
  const defaultMinDistance = 30;
  const defaultMaxDistance = 70;
  if (flyEmoji.length) {
    flyEmoji.forEach((b) => {
      b.addEventListener('click', function(event) {
        event.preventDefault();
        const emojiList = this.dataset.emojiList ? this.dataset.emojiList.split(',') : defaultEmojiList;
        const duration = this.dataset.duration ? parseInt(this.dataset.duration, 10) : defaultDuration;
        const intervalTime = this.dataset.intervalTime ? parseInt(this.dataset.intervalTime, 10) : defaultIntervalTime;
        const minDistance = this.dataset.minDistance ? parseInt(this.dataset.minDistance, 10) : defaultMinDistance;
        const maxDistance = this.dataset.maxDistance ? parseInt(this.dataset.maxDistance, 10) : defaultMaxDistance;
        const rect = this.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        const startTime = Date.now();
        const spawnEmoji = () => {
          const elapsed = Date.now() - startTime;
          if (elapsed > duration) {
            clearInterval(spawnInterval);
            return;
          }
          const emoji = document.createElement('span');
          emoji.className = 'emoji';
          const randomEmoji = emojiList[Math.floor(Math.random() * emojiList.length)];
          emoji.textContent = randomEmoji;
          emoji.style.left = centerX + 'px';
          emoji.style.top = centerY + 'px';
          const angle = Math.random() * 2 * Math.PI;
          const distance = minDistance + Math.random() * maxDistance;
          const dx = Math.cos(angle) * distance;
          const dy = Math.sin(angle) * distance;
          emoji.style.setProperty('--dx', dx + 'px');
          emoji.style.setProperty('--dy', dy + 'px');
          document.body.appendChild(emoji);
          emoji.addEventListener('animationend', () => {
            emoji.remove();
          });
        };
        const spawnInterval = setInterval(spawnEmoji, intervalTime);
        setTimeout(() => {
          window.location.href = this.href;
        }, duration);
      });
    });
  }
}